const API_PREFIX = '/api/';
export const endpoints = {
  SAVE_METRICS: API_PREFIX + 'postMetric',
  SESSION: API_PREFIX + 'getSession',
  LOGGER: API_PREFIX + 'logger',

  // PROMOTER
  GENERATE_IDU: API_PREFIX + 'generateIdu',
  CHECK_PROCESS_STATUS: API_PREFIX + 'checkProcessStatus',
  
  // REFERRAL
  VALIDATE_REFERRAL: API_PREFIX + 'validate',
  END_REFERRAL_PROCESS: API_PREFIX + 'endReferralProcess',
  VALIDATE_IDU: API_PREFIX + 'validateIdu',
};

export const ARGENTINA = 'AR';
export const PARAGUAY = 'PY';
export const URUGUAY = 'UY';

export const ALPHANUMERIC_REGEX = /^[a-zA-Z0-9áéíóúÁÉÍÓÚñÑ\s]*$/;
export const ALPHABETIC_REGEX = /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]*$/;
export const NUMERIC_REGEX = /^[0-9]*$/;
export const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
// Teléfono argentino (fijo o móvil), código de área + número, sin el 0 y sin el 15: siempre 10 dígitos, sin cero inicial.
export const PHONE_REGEX = /^[1-9]\d{9}$/;

export const DOCUMENT_TYPES_ARGENTINA = [
  { id: 'DNI', desc: 'DNI', minLength: 7, maxLength: 8 },
  { id: 'EXT', desc: 'Pasaporte', maxLength: 8 },
  { id: 'LC', desc: 'Libreta cívica', maxLength: 7 },
  { id: 'LE', desc: 'Libreta de enrolamiento', maxLength: 7 },
];